<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitRequest)">
        <div class="breadcrumb-area pos-relative w-100">
          <h1>{{ dataRequest.id ? 'Sửa' : 'Thêm mới' }} nhóm ticket</h1>

          <div style="float: right">
            <button type="button" @click="$router.push('/ticket-group')" class="btn btn-light">
              Hủy bỏ
            </button>
            <button class="btn btn-success btn-primary ml-2">
              {{ dataRequest.id ? 'Lưu' : 'Thêm mới' }}
            </button>
          </div>
        </div>
        <div class="card p-10 pt-15 b-t-1-869fb229" style="overflow-x: hidden; overflow-y: auto">
          <div class="card-body px-20 row">
            <div class="col-md-6">
              <ValidationProvider rules="required" vid="sourceInform" name="Dịch vụ">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label">
                    Dịch vụ<span style="color: red"> *</span>
                  </label>
                  <div class="col-sm-9">
                    <Select2
                      :disabled="!!dataRequest.id"
                      v-model="dataRequest.productId"
                      :options="dataProduct"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required|codeGroupTicket" vid="code" name="Mã nhóm ticket">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label"
                    >Mã nhóm ticket<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-9">
                    <input
                      :disabled="!!dataRequest.id"
                      type="text"
                      class="form-control"
                      v-model.trim="dataRequest.code"
                      @input="toUpperCase"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required|minMaxName_7" vid="name" name="Tên nhóm ticket">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label"
                    >Tên nhóm ticket<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-9">
                    <input type="text" class="form-control" v-model.trim="dataRequest.name" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="minMaxName_6" vid="description" name="Mô tả">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label">Mô tả</label>
                  <div class="col-sm-9">
                    <input type="text" class="form-control" v-model="dataRequest.description" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
          </div>
        </div>
      </form>
    </ValidationObserver>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"></VueLoadingOverlay>
  </div>
</template>

<script>
  import { TicketService } from '@/services/ticket.service'
  export default {
    name: 'ticket-group-request',
    data() {
      return {
        dataRequest: {},
        dataProduct: [],
        showLoading: false,
      }
    },
    created() {
      this.fetchDataProduct()
      this.fetchData()
    },
    methods: {
      async fetchDataProduct() {
        try {
          this.showLoading = true
          const response = await TicketService.fetchProduct()
          if (response.code === 1000) {
            response.data.map(e => {
              const arr = { id: e.id, text: e.name }
              this.dataProduct.push(arr)
            })
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async submitRequest() {
        try {
          this.showLoading = true
          const params = {
            code: this.dataRequest.code,
            description: this.dataRequest.description,
            productId: this.dataRequest.productId,
            name: this.dataRequest.name,
          }
          if (this.dataRequest.id) {
            params.id = this.dataRequest.id
            const response = await TicketService.updateGroup(params)
            if (response.success) {
              this.showSuccessMx('Cập nhật nhóm ticket thành công').then(() =>
                this.$router.push('/ticket-group')
              )
            } else this.showFailMx(response.message)
          } else {
            const response = await TicketService.createGroup(params)
            if (response.success) {
              this.showSuccessMx('Thêm mới nhóm ticket thành công').then(() =>
                this.$router.push('/ticket-group')
              )
            } else this.showFailMx(response.message)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      toUpperCase() {
        this.dataRequest.code = this.dataRequest.code.toUpperCase()
        this.dataRequest.code = this.dataRequest.code.replace(/[^\w\sÀ-ỹ]/g, '')
      },
      async fetchData() {
        const ticketId = this.$route.params.id
        if (ticketId) {
          try {
            this.showLoading = true
            const responsive = await TicketService.getDetailGroup({
              id: ticketId,
            })
            this.dataRequest = responsive.data
            this.dataRequest.productId = responsive.data.productRes.id
          } catch (error) {
            console.log(error)
          } finally {
            this.showLoading = false
          }
        }
      },
    },
  }
</script>

<style scoped></style>
